module.exports = __webpack_public_path__ + "static/media/happyyudi.524d4962.jpg";